import React from "react"
import "../style.css"
import Info from "../components/info"
import { Helmet } from "react-helmet"

function index() {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Home | Terence</title>
      </Helmet>
      <Info />
    </div>
  )
}

export default index
